import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HorizontalBarChartView extends Backbone.View
  template: JST['backbone/templates/monitoring/charts/horizontal_bar_chart']
  height: '12px'

  initialize: (@options = {}) ->
    @data = @calculatePercentages(@options.data)

  render: ->
    @$el.html @template
      title: @title
      data: @data
    @

  calculatePercentages: (data) ->
    total = _.reduce(data, ((acum, data) -> acum + data.y), 0)
    _.each(data, (serie) ->
      serie.ptc = if total > 0 then Math.round((serie.y / total) * 100.0) else 0
    )
